module.exports = __webpack_public_path__ + "media/fr_fr_s4_Travis.5f36d52d.mp3";